// Archive watershed is a point between old archive comments and the new stuff.
// Timestamp 1429542260000 means 2015-04-20 15:04:20 UTC, however any date
// between 10 Apr 2015 and 4 May 2015 would work.
const ARCHIVE_WATERSHED_TIMESTAMP = 1429542260000;

export default ARCHIVE_WATERSHED_TIMESTAMP;
